module.exports = __webpack_public_path__ + "img/boutique-icon.6d982741.png";